module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1130.55c70a8a.png";